import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { Mensaje } from '../mensajes2';

export const ImpModalRetenciones = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem('jwtToken');

  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const fechaDesdeRef = useRef();
  const fechaHastaRef = useRef();
  const anioRef = useRef();
  const tipoRetencionRef = useRef();

  const [anios, setAnios] = useState([]);
  const [tipoRet, setTipoRet] = useState([]);
  const [mostrarTipoRetencion, setMostrarTipoRetencion] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: '',
    texto: '',
    icono: 'informacion'
  });

  const titulo = {
    119: 'Listado General de Retenciones',
  };

  const cerrar = () => {
    props.cancelar();
  };

  const handleImprimir = () => {
    if (!fechaDesdeRef.current.value) {
      setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe seleccionar la fecha desde.", icono: "informacion", });
    } else if (!fechaHastaRef.current.value) {
      setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe seleccionar la fecha hasta.", icono: "informacion", });
    }

    if (!anioRef.current.value) {
      setMensaje({ mostrar: true, titulo: "Notificación", texto: "Debe seleccionar el ejercicio fiscal.", icono: "informacion", });
    }

    const val2 = formatFechaJava(fechaDesdeRef.current.value);
    const val3 = formatFechaJava(fechaHastaRef.current.value);
    /* let fileName = (espiritu && [0, 1, 9, 12, 13, 14, 15, 16].includes(espiritu))
      ? "Adm_RetencNumOrden"
      : (tipoRetencionRef.current.value === '1' ? "Adm_RetencIVAISLRNumOrden" : ''); */
    let fileName = tipoRetencionRef.current.value === '0'
      ? "Adm_RetencNumOrden"
      : "Adm_RetencIVAISLRNumOrden";

    window.open(
      op.reportes + "/administracionTesoreria?" +
      "reporte=" + fileName +
      "&efiscal=" + anioRef.current.value +
      "&CONDICION=" + `ORD.Fecha Between '${val2}' AND '${val3}'` +
      "&TIPO=" + tipoRetencionRef.current.value +
      "&TIT_RGO1=" + `DESDE EL '${val2}' HASTA EL '${val3}'` +
      "&HASTA=" + `'${val3}'`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const handleCancelar = () => {
    // Restablecer a valores por defecto
    const fechaActual = new Date().toISOString().split('T')[0];
    const añoActual = new Date().getFullYear().toString();

    if (fechaDesdeRef.current) {
      fechaDesdeRef.current.value = fechaActual;
    }
    if (fechaHastaRef.current) {
      fechaHastaRef.current.value = fechaActual;
    }


    if (tipoRetencionRef.current) {
      tipoRetencionRef.current.value = "0";
    }
  };

  // Función para formatear fecha como en Java: dd-MM-yyyy
  const formatFechaJava = (fechaISO) => {
    const [year, month, day] = fechaISO.split('-');
    return `${day}-${month}-${year}`;
  };


  const seleccionarEjercicioFiscal = () => {

    let campos = '*';
    let nomtab = 'efiscal';
    let orden = 'anio desc';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'

      },
    }).then(function (response) {
      if (response.status === 200) {
        var clase = []
        for (let i = 0; i < response.data.length; i++) {
          clase.push({
            idefiscal: response.data[i].idefiscal,
            descriptor: response.data[i].descriptor,
            anio: response.data[i].anio,
            observaciones: response.data[i].observaciones,
            statusorg: response.data[i].statusorg,
            statuspresup: response.data[i].statuspresup,
            statuspuc: response.data[i].statuspuc,
            statuscat: response.data[i].statuscat,
            idorganizacion: response.data[i].idorganizacion,
            activo: response.data[i].activo,
          })
        }

        setAnios(clase);
        // anioRef.current.value = clase[0].idefiscal;
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
    })
  }

  const seleccionarTipoRetencion = () => {

    let campos = 'idtiporetencion, descripcion';
    let nomtab = 'tiporetencion';
    let orden = 'idtiporetencion asc';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'

      },
    }).then(function (response) {
      if (response.status === 200) {
        setTipoRet(response.data)
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.message, icono: 'error' });
    })
  }

  // Inicializar refs con valores por defecto
  

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarEjercicioFiscal();
    seleccionarTipoRetencion();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          {titulo[props.reporte]}
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />
        <div className="col-md-12 mx-auto row">

          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded mb-3">
            <legend className="float-none text-uppercase w-auto m-0">Buscar Por</legend>
            <div className="col-md-12 mx-auto row my-auto py-0">
              <div className="input-group input-group-sm col-md-5 mb-2">
                <span className="input-group-text text-uppercase">Desde la Fecha:</span>
                <input
                  ref={fechaDesdeRef}
                  type="date"
                  className="form-control text-uppercase"
                  defaultValue={new Date().toISOString().split('T')[0]}
                />
              </div>
              <div className="input-group input-group-sm col-md-5 mb-2">
                <span className="input-group-text text-uppercase">Hasta la Fecha:</span>
                <input
                  ref={fechaHastaRef}
                  type="date"
                  className="form-control text-uppercase"
                  defaultValue={new Date().toISOString().split('T')[0]}
                />
              </div>
            </div>
          </fieldset>

          <fieldset className="col-6 m-0 p-2 d-flex border-azul rounded mb-3">
            <legend className="float-none text-uppercase w-auto m-0">Ejercicio Fiscal</legend>
            <div className="input-group input-group-sm col-md-12 mb-2">
              <span className="input-group-text text-uppercase">Año:</span>
              <select
                ref={anioRef}
                className="form-select"
                defaultValue=""
              >
                {/*<option value="">Seleccione una opción</option>*/}
                {anios.map((anio) => (
                  <option key={anio.idefiscal} value={anio.idefiscal}>
                    {anio.descriptor}
                  </option>
                ))}
              </select>
            </div>
          </fieldset>

          <fieldset className="col-6 m-0 p-2 d-flex border-azul rounded mb-3">
            <legend className="float-none text-uppercase w-auto m-0">Tipo de Retenciones</legend>
            <div className="input-group input-group-sm col-md-12 mb-2">
              <span className="input-group-text text-uppercase">Tipo:</span>
              <select
                ref={tipoRetencionRef}
                className="form-select"
                defaultValue="0"
              >
                <option value="0">Todas</option>
                {tipoRet.map((tipo) => (
                  <option key={tipo.idtiporetencion} value={tipo.idtiporetencion}>
                    {tipo.descripcion}
                  </option>
                ))}
              </select>
            </div>
          </fieldset>

        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div className="col-md-12 row mx-auto d-flex justify-content-end px-0">
          <Button
            variant="primary"
            onClick={handleImprimir}
            className="me-2 col-md-2 btn-sm rounded-pill"
          >
            <i className="fas fa-print me-1"></i> Imprimir
          </Button>
          <Button
            variant="secondary"
            onClick={handleCancelar}
            className="me-2 col-md-2 btn-sm rounded-pill"
          >
            <i className="fas fa-ban me-1"></i> Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={cerrar}
            className="me-2 col-md-2 btn-sm rounded-pill"
          >
            <i className="fas fa-times me-1"></i> Salir
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};